<nav>
    <ul class="footer-nav">
        <li class="links">
            <a href="http://go.youthhostel.ch/agb/br" target="_blank">{{'gtc' | translate}}</a>
            <a href="http://go.youthhostel.ch/datenschutz/br" target="_blank">{{'privacy' | translate}}</a>
            <a href="http://go.youthhostel.ch/impressum/br" target="_blank">{{'legalDetails' | translate}}</a>
        </li>
    </ul>
</nav>